<template>
  <template v-if="row['row101']">
    <div v-for="(zone, index) in row['row101'].zones" :key="'row101_' + index" class="text-container padding-left-xs">
      <MediaTypes :zone="zone" />
    </div>
  </template>

  <template v-else-if="row['row102']">
    <MediaTypes :zone="row['row102'].zones[0]" />
    <MediaTypes :zone="row['row102'].zones[1]" />
  </template>

  <template v-else-if="row['row103']?.zones.length">
    <template v-if="row['row103'].zones[0].numberOfPromotions > 0 && envProps.entryPoint === 'mcom'">
      <div class="text-container" style="width: 100%">
        <div class="grid-x align-left">
          <template v-for="(zone2, index) in row['row103'].zones" :key="'row103_' + index">
            <div v-if="zone2.numberOfPromotions == undefined" class="cell align-left align-left small-12 medium-6 large-4 grid-x">
              <MediaTypes :zone="zone2" />
            </div>
          </template>
        </div>
      </div>
    </template>

    <template v-else-if="row['row103'].zones[0].numberOfPromotions > 0 && envProps.entryPoint === 'bcom'">
      <template v-for="(zone2, index) in row['row103'].zones" :key="'row103_' + index">
        <div
          v-if="zone2.numberOfPromotions == undefined"
          class="grid-x cell small-4 promo-container padding-right-xs padding-left-xs padding-top-xxs"
        >
          <MediaTypes :zone="zone2" />
        </div>
      </template>
    </template>

    <template v-else>
      <br />
      <!-- display image map for row103 -->
      <div v-if="row['row103'].zones[0].imageMap.children.length > 0" class="imageMap-container row_10">
        <div v-for="(zone1, index) in row['row103'].zones" :key="'map_' + index">
          <ImageMap class="imageMap" :image-map="zone1.imageMap" />
        </div>
      </div>
    </template>
  </template>

  <template v-else>
    <div class="cell">
      <div class="grid-x small-4">
        <template v-if="row['row104']?.zones.length">
          <div v-for="(zone, index) in row['row104'].zones" :key="'row104_' + index" class="cell image-container padding-xl">
            <MediaTypes :zone="zone" />
          </div>
        </template>
      </div>
    </div>
  </template>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import ImageMap from '~/components/mediaTypes/imageMap.vue';
import MediaTypes from '~/components/mediaTypes/mediaTypes.vue';
import { useEnvPropsStore } from '~/stores/envProps';

defineProps({
  row: {
    type: Object,
    default() {
      return {};
    },
  },
});

const envPropsStore = useEnvPropsStore();
const envProps = computed(() => envPropsStore.envProps);
</script>

<style style lang="scss" scoped>
.text-container {
  width: 100%;
  padding-top: rem-calc(20);
}

.imageMap-container {
  display: flex;
  flex-flow: row wrap;
}
.rowType103 > ul {
  margin-left: rem-calc(0);
}
ul li::marker {
  color: $white;
  font-size: rem-calc(0);
}
.large-up-3 > .cell {
  width: 34%;
}

.imageMap-container {
  .imageMap {
    width: rem-calc(530);
  }
}
@media only screen and (max-width: rem-calc(400)) {
  .imageMap-container {
    .imageMap {
      width: rem-calc(330);
    }
  }
}
@media only screen and (max-width: rem-calc(600)) {
  .promo-container {
    width: 100%;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
.image-container {
  width: 25%;
}
@media only screen and (max-width: rem-calc(600)) {
  .image-container {
    width: 50%;
  }
}
</style>
